module.exports = __webpack_public_path__ + "static/ArcherRx-Low-Cost-Prescriptions-min-5873ee47c6ba860f3ea4ad18430f76e8.png";